import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-cms',
  templateUrl: './cms.component.html',
  styleUrls: ['./cms.component.scss']
})
export class CmsComponent implements OnInit {
  pageTitle: any;
  constructor(
    public route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.pageTitle = this.route.snapshot.data.title;
  }

}
